import React from "react";

export const Catering = () => {
  return (
    <section
      id="catering"
      data-testid="catering-section"
      className="relative bg-stone-950 py-24 sm:py-32 lg:py-40 border-t border-stone-900"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-orange-500 font-proxima text-xs uppercase tracking-[0.32em] font-semibold mb-6">
            07 — Catering Coming Soon
          </p>
          <h2
            className="font-serif-display text-stone-50 text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight"
            data-testid="catering-heading"
          >
            Planning an event?
          </h2>
          <p className="mt-8 text-stone-300 font-sans-display text-base sm:text-lg leading-relaxed">
            Authentic Kitchen will offer custom catering experiences designed to
            impress — perfect for corporate events, weddings, and private
            gatherings.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Catering;
